export const MAP_CONFIG = {
    BASE_MAP_URL: 'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png?key=cb1_3g3b_1_7838d64c4364a9a4eb1a100f',
    MAX_ZOOM: 18,
    MIN_ZOOM: 2,
    ZOOM: 2,
    ATTRIBUTION: '...',
    CONTROL_POSITION: 'topright',
    DEFAULT_FIELDS: {
        LAT: 'lat',
        LON: 'lon',
        VALUE: 'count'
    }
};
